const courseType = {
  SEGMENT: 'segment',
  MAIL: 'mail',
};

export default courseType;
